import React from "react";
import { Route, Routes } from "react-router-dom";

import Subscribe from "@/components/screens/Subscribe";
import { SUBSCRIBE_MESSAGES } from "@/messages/subscribe/subscribe.messages";

const SubscribePage: React.FC = () => {
  return (
    <Routes>
      <Route
        path="/:salesproductpriceId/:lang"
        element={<Subscribe messages={SUBSCRIBE_MESSAGES} />}
      />
      <Route path="/" element={<Subscribe messages={SUBSCRIBE_MESSAGES} />} />
    </Routes>
  );
};

export default SubscribePage;
